import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http'
import {SiteReferenceService} from "./site-reference.service";

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private http: HttpClient, private siteReference: SiteReferenceService) {
  }

  parseVariableLookup() {
    return this.http.get(this.siteReference.cfStandandardNamesUrl).toPromise()
      .then(response => {
        const $result: Element = $(response).get(0) as Element;
        const $parent = $('<div></div>');
        $parent.append($result);
        const $tr = $parent.find('#standard_name_table tr');

        const lookup = {};

        for (let i = 0; i < $tr.length; i++) {
          var tr = $tr[i];
          var td = tr.children[0];
          var $td = $(td);
          var code = $td.find('code').text();
          var description = $td.find('div').text().trim();

          if (code) {
            if (description && description.indexOf('No help') < 0) {
              lookup[code] = description;
            }
          }
        }

        return lookup;
      }).catch(error => {
        console.error(error);
      });
  }

  getVariableLookup() {
    //return $.getJSON("/static/data/data.variableLookup.json");
    return $.getJSON("/gliders/api/variable_lookup/");
  }

  graph(dataset: string, variable: string, color_variable?: string, descending?: string, period?: string, end_time?: string, start_time?: string) {
    let params = new HttpParams().append('dataset', dataset).append('variable', variable);
    if (color_variable) {
        params = params.append('color_variable', color_variable);
    }
    if (descending) {
        params = params.append('descending', descending);
    }
    if (period) {
      params = params.append('period', period)
    }
    if (end_time) {
      params = params.append('end_time', end_time)
    }
    if (start_time) {
        params = params.append('start_time', start_time)
    }
    return this.http.get('/gliders/api/graph/', {params: params, responseType: 'text'}).toPromise();
  }

  getErddapDataset(dataset_id: string, main_variable: string, variables: string[], start_time?: string, end_time?: string) {
    let params = new HttpParams().append('dataset_id', dataset_id).append('main_variable', main_variable);
    if (variables) {
        params = params.append('variables', variables.join(','));
    }
    if (start_time) {
      params = params.append('start_time', start_time)
    }
    if (end_time) {
      params = params.append('end_time', end_time)
    }
    return this.http.get("/gliders/api/get_erddap_dataset/", {params: params, responseType: 'json'}).toPromise();
  }

}
